export default __webpack_public_path__ + "static/media/specialist@2x.af97e232.png";